import React from 'react';

export const TechSupportIcon = ({ className, ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 59.79 60"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    className={className}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.72 46.28a77.73 77.73 0 0 1-3.78-4.06l-7.56 7.33A6 6 0 1 0 11 57.93l7-7.67c-1.48-1.26-2.92-2.63-4.28-3.98zM9 56.18a3.38 3.38 0 1 1 0-4.78 3.38 3.38 0 0 1 0 4.78zm26.5-40.44a12.31 12.31 0 0 1-.95-4.63A10.93 10.93 0 0 1 46.72 0a12.41 12.41 0 0 1 1.47.28l-3.9 5.62a5.05 5.05 0 0 0 1.25 7l.8.56a5.05 5.05 0 0 0 7-1.25l3.76-5.3a12.83 12.83 0 0 1 1.74 6.31 10.93 10.93 0 0 1-12.12 11.07 11.87 11.87 0 0 1-3-.7 5.06 5.06 0 0 0-.57-.05 1.85 1.85 0 0 0-1.31.54L31.66 35.29A49.4 49.4 0 0 1 28 32a48 48 0 0 1-3.48-3.86l10.62-10.3a1.85 1.85 0 0 0 .4-2.1zm23.99 36.45l-3.18 3.11a3.13 3.13 0 0 1-.47.47 16.67 16.67 0 0 1-18.63 2.44 84.09 84.09 0 0 1-20.45-15 84.09 84.09 0 0 1-15-20.45A16.68 16.68 0 0 1 4.22 4.17c.14-.17.34-.34.48-.55L7.88.51a1.06 1.06 0 0 1 1.49 0l13.34 13.27a1.06 1.06 0 0 1 0 1.49l-3 3-.14.14-2.44 2a2.2 2.2 0 0 0-.68 2.64c.95 2.24 3.18 6.5 8.53 11.85s9.62 7.65 11.85 8.53a2.2 2.2 0 0 0 2.64-.68l2-2.44 3.18-3.18a1.06 1.06 0 0 1 1.49 0l13.28 13.43a1.16 1.16 0 0 1 .07 1.63z"
    />
  </svg>
);
